import classNames from 'clsx';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardLoading from '@swf/core/hooks/useWizardLoading';

import type { Props } from '../Button/Button';
import Button from '../Button/Button';

import { TXTWCL_Continue } from './CTAButton.messages.json';

const CTAButton: React.FC<React.PropsWithChildren<Props>> = ({
  type = 'submit',
  translation = TXTWCL_Continue,
  className,
  ...rest
}) => {
  const {
    data: { cmsHeaderAndGridLayout }
  } = useWizardContext();
  const { loading } = useWizardLoading();

  return (
    <Button
      type={type}
      translation={translation}
      className={classNames(className)}
      loading={loading}
      {...(cmsHeaderAndGridLayout && { align: 'left' })}
      {...rest}
    />
  );
};
export default CTAButton;
